import type { WakeOrbProps } from "@/components/WakeOrb";

/** The copy-only screens: still booting, or the assistant can't run at all. */
export type StatusScreen = "boot" | "unavailable";

/**
 * Both screens are the same stage in a different mood, so they are config
 * rather than separate trees — the orb props below are the whole difference.
 */
export const STATUS_SCREENS: Record<
  StatusScreen,
  { orb: WakeOrbProps; statusClassName: string }
> = {
  boot: {
    orb: { state: "dormant", level: 0 },
    statusClassName: "assistant__status assistant__status--boot",
  },
  unavailable: {
    orb: { state: "speaking", level: 0.25 },
    statusClassName: "assistant__status",
  },
};
